module.exports = __webpack_public_path__ + "4d1343be4669171aac561f6eb3efc43b.svg";